import type React from "react";
import type {
  AiProviderId,
  OnboardingPermissionId,
  OnboardingPermissionStatus,
  OnboardingSurface,
  TraderProfile,
} from "../../lib/onboarding-v2";
import { WelcomeDeskStep } from "./WelcomeDeskStep";
import { WelcomePermissionsStep } from "./WelcomePermissionsStep";
import { WelcomeProfileStep } from "./WelcomeProfileStep";
import { WelcomeProviderStep } from "./WelcomeProviderStep";
import type { BusyState, WelcomeStep } from "./welcome-onboarding-types";

interface WelcomeStepBodyProps {
  apiKey: string;
  busy: BusyState;
  fileRef: React.RefObject<HTMLInputElement | null>;
  isBusy: boolean;
  oauthCommand: string | null;
  onApiKeyChange: (value: string) => void;
  onAvatar: (file: File | null) => void;
  onConfirmGrok: () => void;
  onCreateDesk: (name: string) => void;
  onJoinPic: () => void;
  onPermissionContinue: () => void;
  onPermissionRequest: (id: OnboardingPermissionId) => void;
  onPermissionSkip: (id: OnboardingPermissionId) => void;
  onProfileSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onProfileUpdate: <K extends keyof TraderProfile>(
    key: K,
    value: TraderProfile[K],
  ) => void;
  onProviderChange: (provider: AiProviderId) => void;
  onProviderSubmit: () => void;
  permissionStatuses: Partial<
    Record<OnboardingPermissionId, OnboardingPermissionStatus>
  >;
  profile: TraderProfile;
  provider: AiProviderId;
  step: WelcomeStep;
  surface: OnboardingSurface;
}

export function WelcomeStepBody(props: WelcomeStepBodyProps) {
  if (props.step === "profile") {
    return (
      <WelcomeProfileStep
        busy={props.busy}
        fileRef={props.fileRef}
        isBusy={props.isBusy}
        onAvatar={props.onAvatar}
        onSubmit={props.onProfileSubmit}
        onUpdate={props.onProfileUpdate}
        profile={props.profile}
      />
    );
  }
  if (props.step === "permissions") {
    return (
      <WelcomePermissionsStep
        busy={props.busy}
        isBusy={props.isBusy}
        onContinue={props.onPermissionContinue}
        onRequest={props.onPermissionRequest}
        onSkip={props.onPermissionSkip}
        statuses={props.permissionStatuses}
      />
    );
  }
  if (props.step === "desk") {
    return (
      <WelcomeDeskStep
        busy={props.busy}
        isBusy={props.isBusy}
        onCreateDesk={props.onCreateDesk}
        onJoinPic={props.onJoinPic}
        profile={props.profile}
      />
    );
  }
  return (
    <WelcomeProviderStep
      apiKey={props.apiKey}
      busy={props.busy}
      isBusy={props.isBusy}
      oauthCommand={props.oauthCommand}
      onApiKeyChange={props.onApiKeyChange}
      onConfirmGrok={props.onConfirmGrok}
      onProviderChange={props.onProviderChange}
      onSubmit={props.onProviderSubmit}
      provider={props.provider}
      surface={props.surface}
    />
  );
}
